import * as z from "zod/v4";
import { string } from "zod/v4";
export const ConfirmContactSupport = z.object({
  customerEmail: string().optional(),
});
